import { useEffect, useState, useReducer, useCallback } from 'react'
import logger from '@achieve/cx-logger'
import { parseApiResponse } from './parseApiResponse'

const sliderReducer = (state, action) => {
  switch (action.type) {
    case 'SET_SELECTED_VALUE':
      return {
        ...state,
        selectedValue: action.payload,
      }
    case 'SET_COMMITTED_VALUE':
      return {
        ...state,
        selectedValue: action.payload,
        committedValue: action.payload,
      }
    default:
      return state
  }
}

const DEFAULT_RESULTS = [
  {
    resultMonthly: 557,
    resultTotal: 33478,
    resultMonths: 60,
    active: true,
    unavailableText: 'For debt amounts above $50,000',
  },
  {
    resultMonthly: 230,
    resultTotal: 41485,
    resultMonths: 180,
    active: true,
    unavailableText: 'For debt amounts below $15,000',
  },
  {
    resultMonthly: 368,
    resultTotal: 18500,
    resultMonths: 49,
    active: true,
    unavailableText: 'Unavailable',
  },
  {
    resultMonthly: 728,
    resultTotal: 71324,
    resultMonths: 375,
  },
]

export function useDebtAssessment(sliderConfig, apiUrl, defaultValues) {
  const [sliderState, dispatch] = useReducer(sliderReducer, {
    selectedValue: sliderConfig?.default || 20000,
    committedValue: sliderConfig?.default || 20000,
  })

  const { selectedValue, committedValue } = sliderState
  const [isLoading, setIsLoading] = useState(false)
  const [results, setResults] = useState(defaultValues || DEFAULT_RESULTS)

  const handleChange = useCallback((_e, value) => {
    dispatch({ type: 'SET_SELECTED_VALUE', payload: value })
  }, [])

  const handleChangeCommitted = useCallback((_e, value) => {
    dispatch({ type: 'SET_COMMITTED_VALUE', payload: value })
  }, [])

  useEffect(() => {
    let cancelled = false

    const fetchAssessment = async () => {
      setIsLoading(true)
      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify({ estimated_debt: committedValue }),
        })
        const resultJson = await response.json()
        if (!cancelled) {
          setResults((prev) => parseApiResponse(resultJson, prev))
        }
      } catch (error) {
        logger.error('Debt assessment fetch failed', { error })
      } finally {
        if (!cancelled) {
          setIsLoading(false)
        }
      }
    }

    fetchAssessment()
    return () => {
      cancelled = true
    }
  }, [committedValue, apiUrl])

  return {
    selectedValue,
    isLoading,
    results,
    handleChange,
    handleChangeCommitted,
    sliderConfig,
  }
}
